<template>
    <div>
        <Header></Header>
        <en-savoir-plus></en-savoir-plus>
        <Navbar></Navbar>
        <Contenu>
            <slot/>
        </Contenu>
        <Footer></Footer>
    </div>
</template>

<script>

import Header from './Header.vue';
import EnSavoirPlus from './EnSavoirPlus.vue';
import Navbar from './Navbar.vue';
import Contenu from './Contenu.vue';
import Footer from './Footer.vue';

export default {
  name: 'layout-default',
  components: {
    Contenu,
    EnSavoirPlus,
    Header,
    Navbar,
    Footer,
  },
};
</script>

<style scoped>

</style>
